import React, { createContext } from "react";
import { ShowToast, Severty } from "../helper/toast";
import { podcastAPI } from "../services/api";
export const PodcastContext = createContext();

export const PodcastProvider = ({ children }) => {
  //get all podcasts
  const loadPodCasts = async (params) => {
    try {
      params = {
        page: Number(params.page),
        limit: Number(params.limit),
        search: params.search || undefined,
        ...params,
      };
      const response = await podcastAPI.loadPodCasts(params);
      return { status: response.status, data: response.data };
    } catch (error) {
      ShowToast(error.message || "Failed to load podcasts", Severty.ERROR);
      return {
        success: false,
        error: error.message || "Failed to load podcasts",
      };
    }
  };

  //get single podcast
  const loadPostCastById = async (podcastId) => {
    try {
      const response = await podcastAPI.loadPostCastById(podcastId);
      return { status: response.status, data: response.data };
    } catch (error) {
      ShowToast(error.message || "Failed to load podcast", Severty.ERROR);
      return {
        success: false,
        error: error.message || "Failed to load podcast",
      };
    }
  };

  //get comments for single podcast
  const loadPodcastComments = async (podcastId) => {
    try {
      const response = await podcastAPI.loadPodcastComments(podcastId);
      return { status: response.status, data: response.data };
    } catch (error) {
      ShowToast(error.message || "Failed to load");
    }
  };

  //write comment for a podcast
  const writePodcastComment = async (podcastId, comment) => {
    try {
      const response = await podcastAPI.writePodcastComment(podcastId, comment);
      return { status: response.status, data: response.data };
    } catch (error) {
      ShowToast(error.message || "Failed to load");
    }
  };

  //add post cast like
  const addPodcastLike = async (podcastId) => {
    try {
      const response = await podcastAPI.addPodcastLike(podcastId);
      return { status: response.status, data: response.data };
    } catch (error) {
      ShowToast(error.message || "Failed to load");
    }
  };

  //remove podcast like
  const removePodcastLike = async (podcastId) => {
    try {
      const response = await podcastAPI.removePodcastLike(podcastId);
      return { status: response.status, data: response.data };
    } catch (error) {
      ShowToast(error.message || "Failed to load");
    }
  };

  return (
    <PodcastContext.Provider
      value={{
        loadPodCasts,
        loadPostCastById,
        loadPodcastComments,
        writePodcastComment,
        addPodcastLike,
        removePodcastLike,
      }}
    >
      {children}
    </PodcastContext.Provider>
  );
};

// Custom hook to use the auth context
export const usePodcast = () => {
  const context = React.useContext(PodcastContext);
  if (context === undefined) {
    throw new Error("usePodcast must be used within an PodcastProvider");
  }
  return context;
};
